<template>
    <a-modal v-model="visible" title="审核不通过" on-ok="handleSubmit">
        <template slot="footer">
            <a-button key="submit" type="primary" :loading="loading" @click=" handleSubmit">
            确定
            </a-button>
            <a-button key="back"   @click="handleCancel">
            取消
            </a-button>
        </template>

        <a-form  :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" @submit="handleSubmit">
            <a-form-item label="审核失败原因">
                <a-textarea
                  v-model="auditFailReason"
                  placeholder="请输入"
                  :maxLength="500"
                  :auto-size="{ minRows: 9, maxRows: 12 }"
                />
            </a-form-item>
        </a-form>

    </a-modal>
</template>
<script>
import {batchAudit} from "@/api/product";
export default {
  props:{
    // value:''
    mdseIds:{
      type:Number,
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      auditFailReason:'',
    };
  },
  methods: {
    handleSubmit() {
      batchAudit({
        auditFailReason: this.auditFailReason,
        mdseIds: [this.mdseIds],
        mdseStatus: 20
      }).then(res => {
          if (res.result) {
            this.visible = false;
            this.$message.success("操作成功",1,()=>{
              this.$router.push({name:"product-manage"})
            });
          }else{
            this.$message.warning(res.message)
          }
        });
    },
    showModal() {
      this.auditFailReason = ''
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
    },
  },
};
</script>
